import React from 'react'
import { Provider as ReduxProvider } from 'react-redux'
import '@aws-amplify/ui-react/styles.css'
import { Amplify } from 'aws-amplify'
import { ThemeProvider } from '@aws-amplify/ui-react'
import '@styles/vars.scss'
import '@styles/app.scss'
import store from '@redux/store'
import AppRoutes from './routes'
import awsexports from './aws-exports'

Amplify.configure(awsexports)

const App: React.FC = () => {
    
    return(

        <>
            <ThemeProvider>
                <ReduxProvider store = {store}>
                    <AppRoutes />
                </ReduxProvider>
            </ThemeProvider>
        </>

    )

}

export default App